import React, { forwardRef } from "react";
import styles from "./JsonViewer.module.sass";
import { format, date, datetime } from "../../../utils/index";
import I18n from "../../../I18n";

function stringInputValidation(stringInput) {
    const dateRegex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}\.\d{3})Z/gm;
    const match = stringInput && stringInput.match(dateRegex);
    if (match) {
        const auxDate = new Date(stringInput);
        if (isNaN(auxDate.getTime())) {
            return {
                type: "string",
                value: "",
            };
        }
        return {
            type: "date",
            value:
                auxDate && 
                auxDate.getUTCHours() === 0 &&
                auxDate.getUTCMinutes() === 0 &&
                auxDate.getUTCSeconds() === 0
                    ? date(auxDate)
                    : datetime(auxDate),
        };
    } else {
        return {
            type: "string",
            value: stringInput || "",
        };
    }
}

function determinateRawDataVariableType(value) {
    switch (typeof value) {
        case "string":
            return stringInputValidation(value)
        case "number":
            return {
                type: "number",
                align: "right",
                value: format(value, "normal", null),
            };
        default:
            return { type: "string", value };
    }
}

const renderJson = (json, entityLabel) => {
    return Object.entries(json).map(([key, value], index) => {
        const replacedKey = `${key || ""}`.replace(/([A-Z])/g, " $1")
            .replace(/([A-Z])\s(?=[A-Z])/g, "$1");
        const translatedKey = I18n.translate(replacedKey.toLowerCase().trim())

        const dataType = determinateRawDataVariableType(value);
        if (value && typeof value === "object") {
            return (
                <div key={index} className={styles["inner-object"]}>
                    <strong className={styles["label"]}>{entityLabel || key}</strong>
                    <div className={styles["group"]}>{renderJson(value || {})}</div>
                </div>
            );
        }
        return (
            <div key={index} className={styles["entry"]}>
                <div>
                    <small className={styles["label"]}>
                        {entityLabel ||
                            translatedKey}
                    </small>
                </div>
                <div>
                    <span
                        className={`${styles["input"]} ${
                            dataType && dataType.align && styles[`align-${dataType.align}`]
                        }`}
                    >
                        {dataType.value || "N/A"}
                    </span>
                </div>
            </div>
        );
    });
};

const JsonViewer = (props, ref) => {
    const { data, entity = null } = props;

    const json = renderJson(data || {}, entity);

    return (
        <div className={styles["root"]}>
            <div className={styles["content"]}>{json}</div>
        </div>
    );
};

const JsonViewerRef = forwardRef(JsonViewer);

export default JsonViewerRef;
